var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWebsiteInfo = function SvgWebsiteInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.529,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7abfac",
    d: "M18.391 13.242A6.627 6.627 0 0 1 24 23.394l4.532 4.561L26.484 30l-4.59-4.517a6.621 6.621 0 1 1-3.5-12.241m0 2.943a3.678 3.678 0 1 0 3.678 3.678 3.68 3.68 0 0 0-3.678-3.678M2.943 0h20.6a2.93 2.93 0 0 1 2.943 2.943v11.814a10 10 0 0 0-2.943-2.987V2.943h-20.6v20.6h6.621a9.6 9.6 0 0 0 1.927 2.943H2.943A2.93 2.93 0 0 1 0 23.541V2.943A2.93 2.93 0 0 1 2.943 0m2.942 5.885H20.6v2.943H5.885zm0 5.885h7.4a10 10 0 0 0-2.985 2.943H5.885zm0 5.885h3.193a10.3 10.3 0 0 0-.25 2.207v.738H5.885Z"
  })));
};
export default SvgWebsiteInfo;